<!-- <mat-toolbar [@toggleTrigger]="isShown ? 'open' : (minifyOnClose ? 'minified': 'closed')"
*ngIf="isShown || minifyOnClose"
class="message-bar {{cssClass}} message-bar-{{messageType}}"
[class.minified]="minifyOnClose && !isShown"
[color]="colorTheme"
[mtxTooltip]="(minifyOnClose && !isShown) ? tooltipTpl: null"
mtxTooltipPosition="above"
#ttp="mtxTooltip">
<span class="message-content"
  [innerHTML]="htmlMessage"
(click)="ttp.show(0)"></span>
<ng-template #tooltipTpl>
  <span class="tooltip-message-content"
  [innerHTML]="message | sanitizeHtml"></span>
</ng-template> -->

@if (isShown || minifyOnClose) {
  <mat-toolbar [@toggleTrigger]="isShown ? 'open' : (minifyOnClose ? 'minified': 'closed')"
    class="message-bar {{cssClass}} message-bar-{{messageType}}"
    [ngClass]="{'closable': canClose}"
    [class.minified]="minifyOnClose && !isShown"
    [color]="colorTheme">
    <div (click)="onMessageClick()"
      class="message-content"
      #contentContainer
      (pan)="onPan($event)">
      @if (message) {
        <span
        [innerHTML]="message | sanitizeHtml"></span>
      }
      <div #content>
        <ng-content></ng-content>
      </div>
    </div>
    @if (canClose && !(minifyOnClose && !isShown)) {
      <button mat-icon-button
        class="close-icon"
        (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-toolbar>
}
